import Activity, {
  ActivityOptions,
  ActivityType,
  BaseActivityData,
  BaseActivityDataOptions,
  getDefaults as getActivityDefaults,
} from 'models/Activity';

export interface ReferralOptions extends ActivityOptions {
  type: ActivityType.REFERRAL;
  data: Partial<BaseActivityDataOptions>;
}

export function getDefaults(): ReferralOptions {
  return {
    ...getActivityDefaults(),
    type: ActivityType.REFERRAL,
  };
}

export default class Referral extends Activity {
  declare type: ActivityType.REFERRAL;
  declare data: BaseActivityData;

  constructor(options: Partial<ReferralOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);
  }

  get typeLabel() {
    return 'Referral Update';
  }
}
